import { render, staticRenderFns } from "./ContractMergePlaceholderDialog.vue?vue&type=template&id=4dd7d257&scoped=true"
import script from "./ContractMergePlaceholderDialog.vue?vue&type=script&lang=js"
export * from "./ContractMergePlaceholderDialog.vue?vue&type=script&lang=js"
import style0 from "./ContractMergePlaceholderDialog.vue?vue&type=style&index=0&id=4dd7d257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd7d257",
  null
  
)

export default component.exports